if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }


      connectedCallback() {
        if (!this.elements.viewer || this.querySelector('.lss-gallery-arrow')) return;
        const viewer = this.elements.viewer;
        const list = viewer.querySelector('.product__media-list');
        if (!list) return;
        if (!document.getElementById('lss-gallery-arrow-style')) {
          const style = document.createElement('style');
          style.id = 'lss-gallery-arrow-style';
          style.textContent = `
            media-gallery [id^="GalleryViewer"]{position:relative}
            .lss-gallery-arrow{position:absolute;top:var(--lss-arrow-top,50%);transform:translateY(-50%);z-index:4;width:48px;height:48px;padding:0;border:1px solid #59453915;border-radius:50%;background:#fffaf2;color:#493226;box-shadow:0 2px 10px #30201620;display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:.4;transition:opacity .2s,background-color .2s,box-shadow .2s}
            .lss-gallery-arrow--prev{left:18px}.lss-gallery-arrow--next{right:18px}
            .lss-gallery-arrow svg{width:22px;height:22px;pointer-events:none}
            [id^="GalleryViewer"]:hover .lss-gallery-arrow{opacity:.8}
            [id^="GalleryViewer"] .lss-gallery-arrow:hover,[id^="GalleryViewer"] .lss-gallery-arrow:focus-visible{opacity:1;background:#fffaf2;box-shadow:0 3px 12px #30201630}
            .lss-gallery-arrow:focus-visible{outline:2px solid #8b3044;outline-offset:3px}
            .lss-gallery-arrow[hidden]{display:none}
            @media(hover:none),(max-width:749px){.lss-gallery-arrow{opacity:1;width:44px;height:44px}.lss-gallery-arrow--prev{left:12px}.lss-gallery-arrow--next{right:12px}}
            @media(prefers-reduced-motion:reduce){.lss-gallery-arrow{transition:none}}
          `;
          document.head.appendChild(style);
        }
        const slides = () => Array.from(list.children).filter(el => el.matches('[data-media-id]') && !el.hidden && !el.classList.contains('product__media-item--variant'));
        const buttons = [-1, 1].map(direction => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'lss-gallery-arrow lss-gallery-arrow--' + (direction < 0 ? 'prev' : 'next');
          button.setAttribute('aria-label', direction < 0 ? 'Previous product image' : 'Next product image');
          button.setAttribute('aria-controls', list.id);
          button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (direction < 0 ? 'M15 4l-8 8 8 8' : 'M9 4l8 8-8 8') + '" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          button.addEventListener('click', () => {
            const items = slides();
            if (items.length < 2) return;
            let index = items.findIndex(el => el.classList.contains('is-active'));
            if (!this.mql.matches) {
              const left = list.getBoundingClientRect().left;
              index = items.reduce((best, el, i) => Math.abs(el.getBoundingClientRect().left-left) < Math.abs(items[best].getBoundingClientRect().left-left) ? i : best, 0);
            }
            this.setActiveMedia(items[(Math.max(index, 0) + direction + items.length) % items.length].dataset.mediaId, false);
          });
          viewer.appendChild(button);
          return button;
        });
        const update = () => {
          const active = list.querySelector('.is-active .product-media-container');
          const rect = (this.mql.matches && active ? active : list).getBoundingClientRect();
          const parentRect = viewer.getBoundingClientRect();
          viewer.style.setProperty('--lss-arrow-top', (rect.top-parentRect.top+rect.height/2)+'px');
          buttons[0].style.left = Math.max(12, rect.left-parentRect.left+12)+'px';
          buttons[1].style.right = Math.max(12, parentRect.right-rect.right+12)+'px';
          buttons.forEach(button => button.hidden = slides().length < 2);
        };
        this.lssArrowResize = new ResizeObserver(update);
        this.lssArrowResize.observe(list);
        this.lssArrowMutation = new MutationObserver(update);
        this.lssArrowMutation.observe(list, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
        update();
      }

      disconnectedCallback() {
        this.lssArrowResize?.disconnect();
        this.lssArrowMutation?.disconnect();
        this.querySelectorAll('.lss-gallery-arrow').forEach(button => button.remove());
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
